import { useCallback } from 'react';
import { EmbedEventTypes, useEmbedStore } from '../components/EmbedContext';

const useAlert = () => {
  const { isEmbed, reportEvent } = useEmbedStore();

  return useCallback((message: string) => {
    if (isEmbed) {
      reportEvent({
        type: EmbedEventTypes.ALERT_MESSAGE,
        payload: { message },
      });
    } else {
      alert(message);
    }

    // TODO: FIX_ESLINT_VIOLATION
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useAlert;
